import styles from "./Button.module.css"
import { useState } from 'react';

export default function Button() {

    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('siteLanguage') || localStorage.getItem('fa') || 'ar';
    });
    
    if(currentLanguage === "fa") {

    return(<>
    <div className={styles.main}>
        <div className={styles.button}>
            نمايش همه
        </div>
    </div>
    </>)
    }else {
        return(<>
            <div className={styles.main}>
                <div className={styles.button}>
                     إظهار المزيد
            </div>
    </div>
    </>)
    }
}